document.documentElement.classList.add('js');
const menuToggle = document.querySelector('.menu-toggle');
const siteNav = document.querySelector('#SiteNav');
if (menuToggle && siteNav) {
  menuToggle.addEventListener('click', () => {
    const open = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!open));
    siteNav.classList.toggle('is-open', !open);
  });
}
const sortSelect = document.querySelector('[data-sort-select]');
if (sortSelect) sortSelect.addEventListener('change', () => {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', sortSelect.value);
  window.location.assign(url.toString());
});
document.querySelectorAll('product-recommendations[data-url]').forEach(async (slot) => {
  try {
    const response = await fetch(slot.dataset.url);
    if (!response.ok) return;
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const section = doc.querySelector('.product-section');
    if (section) slot.replaceWith(section);
  } catch (error) {
    // Recommendations are optional; product purchase remains fully available.
  }
});
